export default __webpack_public_path__ + "static/img-slider-06-b453db50ca784d20524c2a7018f2d995.png";